"use strict";

exports.__esModule = true;
exports.TicketingController = void 0;
var _dissoc2 = _interopRequireDefault(require("ramda/src/dissoc"));
var _react = require("react");
var _constants = require("../../Logbook/constants");
var _User = require("../../User");
var _Time = require("../../Time");
var _Auth = require("../../Auth");
var _DeviceListContext = require("../../Device/DeviceListContext");
var _Utils = require("../../../Utils");
var _constants2 = require("../constants");
var _isValidEmail = require("../../User/isValidEmail");
var _awaitFor = require("../../../Utils/awaitFor");
var _UI = require("../../../Utils/UI");
var _Core = require("../../Core");
var _DataAccessorContext = require("../../API/DataInterface/DataAccessorContext");
var _Profile = require("../../Profile");
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class, _TicketingController;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var getFormattedUserName = function getFormattedUserName(creator, users) {
  if (creator) {
    var user = users ? users.getUser(creator) : null;
    return user ? (0, _Utils.formatUserName)(user) : _constants.INTERNAL_USER;
  }
  return _constants.INTERNAL_USER;
};
var formatTicketResponse = function formatTicketResponse(_ref) {
  var ticket = _ref.ticket,
    deviceList = _ref.deviceList,
    users = _ref.users,
    userId = _ref.userId,
    ticketTypes = _ref.ticketTypes,
    comments = _ref.comments;
  if (ticket) {
    var _history;
    var filteredDevices = ticket.devices.filter(function (device) {
      return device.type === "UUID";
    });
    var tags = ticket.devices.filter(function (device) {
      return device.type === "TAG";
    }).map(function (d) {
      return d.value;
    });
    var devices = filteredDevices.map(function (device) {
      return deviceList.find(function (d) {
        return d.uuid === device.value;
      });
    }).map(function (d) {
      return d && d.name;
    });
    var watchers = ticket.watchers.map(function (watcher) {
      if (watcher.type === "EMAIL") return watcher.value;
      var user = users.getUser(watcher.value);
      return user ? (0, _Utils.formatUserName)(user) : _constants.INTERNAL_USER;
    });
    var types = ticketTypes.filter(function (tt) {
      return ticket.type.includes(tt.id);
    });
    var commentList = [];
    if (comments) {
      commentList = comments.map(function (comment) {
        var _comment$author, _comment$author2, _comment$author3, _comment$author5;
        var user = users.getUser((_comment$author = comment.author) == null ? void 0 : _comment$author.value) || users.getUserByEmail((_comment$author2 = comment.author) == null ? void 0 : _comment$author2.value);
        var creator;
        if (user) {
          creator = (0, _Utils.formatUserName)(user);
        } else if ((0, _isValidEmail.isValidEmail)((_comment$author3 = comment.author) == null ? void 0 : _comment$author3.value)) {
          var _comment$author4;
          creator = (_comment$author4 = comment.author) == null ? void 0 : _comment$author4.value;
        } else {
          creator = _constants.INTERNAL_USER;
        }
        return {
          id: comment.id,
          body: comment.body,
          created: new Date(comment.timestamp).getTime(),
          creator: creator,
          creatorId: (_comment$author5 = comment.author) == null ? void 0 : _comment$author5.value,
          isEdited: comment.isEdited
        };
      });
    }
    var assignee = ticket.assigneeId ? getFormattedUserName(ticket.assigneeId, users) : _constants2.UNASSIGNED;
    var history = ticket.history.map(function (item) {
      item.updator = getFormattedUserName(item.updatorId);
      return item;
    });
    var updated = (_history = history[history.length - 1]) == null ? void 0 : _history.timestamp;
    return Object.assign({}, ticket, {
      watchers: watchers,
      types: types,
      devices: devices,
      tags: tags,
      userId: userId,
      assignee: assignee,
      history: history,
      creator: getFormattedUserName(ticket.creatorId, users),
      created: new Date(ticket.created).getTime(),
      updated: updated,
      comments: commentList.reverse()
    });
  }
};
var TicketingController = exports.TicketingController = (_dec = _User.UserListContext.withContext, _dec2 = _Auth.AuthContext.withContext, _dec3 = _Time.TimeContext.withContext, _dec4 = _DeviceListContext.DeviceListContext.withContext, _dec5 = _DataAccessorContext.DataAccessorContext.withContext, _dec6 = _Profile.ProfileContext.withContext, _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = _dec5(_class = _dec6(_class = (0, _Core.withTranslator)(_class = (_TicketingController = /*#__PURE__*/function (_Component) {
  function TicketingController() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      lastCreatedTicket: "0",
      loading: false,
      ticketList: [],
      ticketTypes: [],
      filteredTicketTypes: [],
      createNewTicket: function () {
        var _createNewTicket = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(ticketData) {
          var _this$props, username, translate, users, dataAccessor, creator, watcherQuery, _yield$awaitFor, watchers, ticketQuery, body, _yield$awaitFor2, error, ticket;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                _this$props = _this.props, username = _this$props.auth.username, translate = _this$props.translator.translate, users = _this$props.users, dataAccessor = _this$props.dataAccessor;
                creator = ticketData.creator ? ticketData.creator : users.getUserByName(username);
                watcherQuery = {
                  devices: ticketData.devices,
                  types: ticketData.type,
                  timezone: _this.props.time.timezone.name
                };
                _context.n = 1;
                return (0, _awaitFor.awaitFor)(dataAccessor.getWatcherRules(watcherQuery));
              case 1:
                _yield$awaitFor = _context.v;
                watchers = _yield$awaitFor[1];
                watchers = watchers.map(function (watcher) {
                  if (!watcher.actions || watcher.actions.length === 0) {
                    return Object.assign({}, watcher, {
                      actions: _constants2.DEFAULT_ACTIONS
                    });
                  } else {
                    return watcher;
                  }
                });
                ticketQuery = (0, _dissoc2["default"])("creator", ticketData);
                body = Object.assign({}, ticketQuery, {
                  creatorId: creator && creator.id ? creator.id : "",
                  watchers: watchers.map(function (_ref2) {
                    var type = _ref2.type,
                      value = _ref2.value,
                      actions = _ref2.actions;
                    return {
                      type: type,
                      value: value,
                      actions: actions
                    };
                  })
                });
                _context.n = 2;
                return (0, _awaitFor.awaitFor)(dataAccessor.createTicket(body));
              case 2:
                _yield$awaitFor2 = _context.v;
                error = _yield$awaitFor2[0];
                ticket = _yield$awaitFor2[1];
                if (!error) {
                  _context.n = 3;
                  break;
                }
                (0, _UI.showErrorToaster)(translate("Ticketing.CreateTicketFail", "Failed to add ticket"));
                throw new Error(error);
              case 3:
                (0, _UI.showSuccessToaster)(translate("Ticketing.CreateTicketSuccess", "Ticket {id} created successfully", {
                  id: ticket == null ? void 0 : ticket.id
                }));
                _this.setState({
                  lastCreatedTicket: ticket == null ? void 0 : ticket.id
                });
              case 4:
                return _context.a(2);
            }
          }, _callee);
        }));
        function createNewTicket(_x) {
          return _createNewTicket.apply(this, arguments);
        }
        return createNewTicket;
      }(),
      getTicketDetails: function () {
        var _getTicketDetails = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(ticketId) {
          var _this$props2, username, users, devices, dataAccessor, user, userId, _yield$Promise$all, ticket, commentResponse;
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                _this$props2 = _this.props, username = _this$props2.auth.username, users = _this$props2.users, devices = _this$props2.devices, dataAccessor = _this$props2.dataAccessor;
                user = users.getUserByName(username);
                userId = user && user.id;
                _context2.n = 1;
                return Promise.all([dataAccessor.getTicket(ticketId), dataAccessor.getTicketComments(ticketId)]);
              case 1:
                _yield$Promise$all = _context2.v;
                ticket = _yield$Promise$all[0];
                commentResponse = _yield$Promise$all[1];
                return _context2.a(2, formatTicketResponse({
                  ticket: ticket,
                  deviceList: devices,
                  users: users,
                  userId: userId || "",
                  ticketTypes: _this.state.ticketTypes,
                  comments: commentResponse
                }));
            }
          }, _callee2);
        }));
        function getTicketDetails(_x2) {
          return _getTicketDetails.apply(this, arguments);
        }
        return getTicketDetails;
      }(),
      updateTicketDetails: function () {
        var _updateTicketDetails = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(ticketId, updateObject) {
          var _this$props3, users, profile, devices, translate, dataAccessor, user, userId, updateTicketQuery, _yield$awaitFor3, error, ticket, commentResponse;
          return _regenerator().w(function (_context3) {
            while (1) switch (_context3.n) {
              case 0:
                _this$props3 = _this.props, users = _this$props3.users, profile = _this$props3.profile, devices = _this$props3.devices, translate = _this$props3.translator.translate, dataAccessor = _this$props3.dataAccessor;
                user = profile.user;
                userId = user && user.id;
                if (!(userId && updateObject)) {
                  _context3.n = 3;
                  break;
                }
                updateTicketQuery = Object.assign({}, updateObject, {
                  updatorId: userId
                });
                _context3.n = 1;
                return (0, _awaitFor.awaitFor)(dataAccessor.updateTicket(ticketId, updateTicketQuery));
              case 1:
                _yield$awaitFor3 = _context3.v;
                error = _yield$awaitFor3[0];
                ticket = _yield$awaitFor3[1];
                if (error) {
                  (0, _UI.showErrorToaster)(translate("Ticketing.UpdateTicketFail", "Failed to update ticket"));
                } else {
                  (0, _UI.showSuccessToaster)(translate("Ticketing.UpdateTicketSuccess", "Ticket updated successfully"));
                }
                _context3.n = 2;
                return dataAccessor.getTicketComments(ticketId);
              case 2:
                commentResponse = _context3.v;
                return _context3.a(2, formatTicketResponse({
                  ticket: ticket,
                  deviceList: devices,
                  users: users,
                  userId: userId,
                  ticketTypes: _this.state.ticketTypes,
                  comments: commentResponse
                }));
              case 3:
                (0, _UI.showErrorToaster)(translate("Ticketing.UpdateTicketFail", "Failed to update ticket"));
              case 4:
                return _context3.a(2);
            }
          }, _callee3);
        }));
        function updateTicketDetails(_x3, _x4) {
          return _updateTicketDetails.apply(this, arguments);
        }
        return updateTicketDetails;
      }(),
      assignTicket: function assignTicket(ticketId) {
        var _this$props4 = _this.props,
          username = _this$props4.auth.username,
          users = _this$props4.users;
        var user = users.getUserByName(username);
        var userId = user && user.id;
        if (userId) {
          var updateQuery = {
            assigneeId: userId
          };
          return _this.state.updateTicketDetails(ticketId, updateQuery);
        }
      },
      assignTicketToUser: function assignTicketToUser(ticketId, userId) {
        if (userId) {
          var updateQuery = {
            assigneeId: userId
          };
          return _this.state.updateTicketDetails(ticketId, updateQuery);
        }
      },
      createTicketComment: function () {
        var _createTicketComment = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(ticketId, comment) {
          var _this$props5, username, users, devices, translate, dataAccessor, user, userId, commentQuery, _yield$awaitFor4, error, _yield$Promise$all2, ticket, commentResponse;
          return _regenerator().w(function (_context4) {
            while (1) switch (_context4.n) {
              case 0:
                _this$props5 = _this.props, username = _this$props5.auth.username, users = _this$props5.users, devices = _this$props5.devices, translate = _this$props5.translator.translate, dataAccessor = _this$props5.dataAccessor;
                user = users.getUserByName(username);
                userId = user && user.id;
                commentQuery = {
                  body: comment,
                  author: {
                    type: "USER",
                    value: userId
                  }
                };
                _context4.n = 1;
                return (0, _awaitFor.awaitFor)(dataAccessor.createTicketComment(ticketId, commentQuery));
              case 1:
                _yield$awaitFor4 = _context4.v;
                error = _yield$awaitFor4[0];
                if (error) {
                  (0, _UI.showErrorToaster)(translate("Ticketing.CreateCommentFail", "Failed to add comment"));
                } else {
                  (0, _UI.showSuccessToaster)(translate("Ticketing.CreateCommentSuccess", "Comment added successfully"));
                }
                _context4.n = 2;
                return Promise.all([dataAccessor.getTicket(ticketId), dataAccessor.getTicketComments(ticketId)]);
              case 2:
                _yield$Promise$all2 = _context4.v;
                ticket = _yield$Promise$all2[0];
                commentResponse = _yield$Promise$all2[1];
                return _context4.a(2, formatTicketResponse({
                  ticket: ticket,
                  deviceList: devices,
                  users: users,
                  userId: userId || "",
                  ticketTypes: _this.state.ticketTypes,
                  comments: commentResponse
                }));
            }
          }, _callee4);
        }));
        function createTicketComment(_x5, _x6) {
          return _createTicketComment.apply(this, arguments);
        }
        return createTicketComment;
      }(),
      editTicketComment: function () {
        var _editTicketComment = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(ticketId, commentId, comment) {
          var _this$props6, translate, dataAccessor, commentBody, _yield$awaitFor5, error;
          return _regenerator().w(function (_context5) {
            while (1) switch (_context5.n) {
              case 0:
                _this$props6 = _this.props, translate = _this$props6.translator.translate, dataAccessor = _this$props6.dataAccessor;
                commentBody = {
                  body: comment
                };
                _context5.n = 1;
                return (0, _awaitFor.awaitFor)(dataAccessor.updateTicketComment(ticketId, commentId, commentBody));
              case 1:
                _yield$awaitFor5 = _context5.v;
                error = _yield$awaitFor5[0];
                if (error) {
                  (0, _UI.showErrorToaster)(translate("Ticketing.EditCommentFail", "Failed to update comment"));
                } else {
                  (0, _UI.showSuccessToaster)(translate("Ticketing.EditCommentSuccess", "Comment updated successfully"));
                }
              case 2:
                return _context5.a(2);
            }
          }, _callee5);
        }));
        function editTicketComment(_x7, _x8, _x9) {
          return _editTicketComment.apply(this, arguments);
        }
        return editTicketComment;
      }(),
      deleteTicketComment: function () {
        var _deleteTicketComment = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(ticketId, commentId) {
          var _this$props7, translate, dataAccessor, _yield$awaitFor6, error;
          return _regenerator().w(function (_context6) {
            while (1) switch (_context6.n) {
              case 0:
                _this$props7 = _this.props, translate = _this$props7.translator.translate, dataAccessor = _this$props7.dataAccessor;
                _context6.n = 1;
                return (0, _awaitFor.awaitFor)(dataAccessor.deleteTicketComment(ticketId, commentId));
              case 1:
                _yield$awaitFor6 = _context6.v;
                error = _yield$awaitFor6[0];
                if (error) {
                  (0, _UI.showErrorToaster)(translate("Ticketing.DeleteCommentFail", "Failed to delete comment"));
                } else {
                  (0, _UI.showSuccessToaster)(translate("Ticketing.DeleteCommentSuccess", "Comment deleted successfully"));
                }
              case 2:
                return _context6.a(2);
            }
          }, _callee6);
        }));
        function deleteTicketComment(_x0, _x1) {
          return _deleteTicketComment.apply(this, arguments);
        }
        return deleteTicketComment;
      }(),
      createNewComment: function () {
        var _createNewComment = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(newComment) {
          var _this$props8, username, dataAccessor, commentPromises, _yield$awaitFor7, error, comments;
          return _regenerator().w(function (_context7) {
            while (1) switch (_context7.n) {
              case 0:
                _this$props8 = _this.props, username = _this$props8.auth.username, dataAccessor = _this$props8.dataAccessor;
                commentPromises = newComment.devices.map(function (device) {
                  return dataAccessor.createComment({
                    author: username,
                    body: newComment.body,
                    entity: "device",
                    entityId: device.value,
                    interval: {
                      startMillis: Date.now(),
                      endMillis: Date.now()
                    }
                  });
                });
                _context7.n = 1;
                return (0, _awaitFor.awaitFor)(Promise.all(commentPromises));
              case 1:
                _yield$awaitFor7 = _context7.v;
                error = _yield$awaitFor7[0];
                comments = _yield$awaitFor7[1];
                if (error) {
                  (0, _UI.showErrorToaster)("Could not create the Comment");
                } else {
                  (0, _UI.showSuccessToaster)("Comment" + (comments && comments.length > 1 ? "s" : "") + " created successfully");
                }
              case 2:
                return _context7.a(2);
            }
          }, _callee7);
        }));
        function createNewComment(_x10) {
          return _createNewComment.apply(this, arguments);
        }
        return createNewComment;
      }(),
      updateComment: function () {
        var _updateComment = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(comment) {
          var _this$props9, username, dataAccessor, commentPromise, _yield$awaitFor8, error, data, _t;
          return _regenerator().w(function (_context8) {
            while (1) switch (_context8.p = _context8.n) {
              case 0:
                _this$props9 = _this.props, username = _this$props9.auth.username, dataAccessor = _this$props9.dataAccessor;
                commentPromise = dataAccessor.updateComment({
                  author: comment.author,
                  interval: comment.interval,
                  body: comment.body,
                  newBody: comment.newBody,
                  entityId: comment.deviceUuid,
                  entity: "device",
                  editedBy: username,
                  editedTimestamp: Date.now()
                });
                _context8.p = 1;
                _context8.n = 2;
                return (0, _awaitFor.awaitFor)(commentPromise);
              case 2:
                _yield$awaitFor8 = _context8.v;
                error = _yield$awaitFor8[0];
                data = _yield$awaitFor8[1];
                if (error) {
                  (0, _UI.showErrorToaster)("Could not update the Comment");
                } else {
                  (0, _UI.showSuccessToaster)("Comment updated successfully");
                }
                return _context8.a(2, data);
              case 3:
                _context8.p = 3;
                _t = _context8.v;
                (0, _UI.showErrorToaster)("Could not update the Comment");
              case 4:
                return _context8.a(2);
            }
          }, _callee8, null, [[1, 3]]);
        }));
        function updateComment(_x11) {
          return _updateComment.apply(this, arguments);
        }
        return updateComment;
      }(),
      deleteComment: function () {
        var _deleteComment = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(comment) {
          var dataAccessor, commentPromise, _yield$awaitFor9, error, data, _t2;
          return _regenerator().w(function (_context9) {
            while (1) switch (_context9.p = _context9.n) {
              case 0:
                dataAccessor = _this.props.dataAccessor;
                commentPromise = dataAccessor.deleteComment({
                  author: comment.author,
                  interval: comment.interval,
                  body: comment.body,
                  entityId: comment.deviceUuid,
                  entity: "device"
                });
                _context9.p = 1;
                _context9.n = 2;
                return (0, _awaitFor.awaitFor)(commentPromise);
              case 2:
                _yield$awaitFor9 = _context9.v;
                error = _yield$awaitFor9[0];
                data = _yield$awaitFor9[1];
                if (error) {
                  (0, _UI.showErrorToaster)("Could not delete the Comment");
                } else {
                  (0, _UI.showSuccessToaster)("Comment deleted successfully");
                }
                return _context9.a(2, data);
              case 3:
                _context9.p = 3;
                _t2 = _context9.v;
                (0, _UI.showErrorToaster)("Could not delete the Comment");
              case 4:
                return _context9.a(2);
            }
          }, _callee9, null, [[1, 3]]);
        }));
        function deleteComment(_x12) {
          return _deleteComment.apply(this, arguments);
        }
        return deleteComment;
      }(),
      // eslint-disable-next-line react/no-unused-state
      fetchTicketTypes: function () {
        var _fetchTicketTypes = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
          var dataAccessor, _yield$Promise$all3, ticketTypesResponse, filteredTicketTypeResponse, filteredTicketTypes, _t3;
          return _regenerator().w(function (_context0) {
            while (1) switch (_context0.p = _context0.n) {
              case 0:
                dataAccessor = _this.props.dataAccessor;
                _context0.p = 1;
                _context0.n = 2;
                return Promise.all([dataAccessor.getTicketTypes(), dataAccessor.filterTicketTypes({
                  devices: [],
                  timezone: _this.props.time.timezone.name
                })]);
              case 2:
                _yield$Promise$all3 = _context0.v;
                ticketTypesResponse = _yield$Promise$all3[0];
                filteredTicketTypeResponse = _yield$Promise$all3[1];
                filteredTicketTypes = ticketTypesResponse.filter(function (ticketType) {
                  return filteredTicketTypeResponse.includes(ticketType.id);
                });
                return _context0.a(2, {
                  filteredTicketTypes: filteredTicketTypes,
                  ticketTypes: ticketTypesResponse
                });
              case 3:
                _context0.p = 3;
                _t3 = _context0.v;
                (0, _UI.showErrorToaster)(JSON.stringify(_t3));
                return _context0.a(2, null);
            }
          }, _callee0, null, [[1, 3]]);
        }));
        function fetchTicketTypes() {
          return _fetchTicketTypes.apply(this, arguments);
        }
        return fetchTicketTypes;
      }(),
      // eslint-disable-next-line react/no-unused-state
      fetchTickets: function () {
        var _fetchTickets = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(ticketQuery) {
          var dataAccessor, _yield$Promise$all4, ticketsResponse, ticketTypesResponse, filteredTicketTypeResponse, ticketList, filteredTicketTypes, ticketing, _t4;
          return _regenerator().w(function (_context1) {
            while (1) switch (_context1.p = _context1.n) {
              case 0:
                dataAccessor = _this.props.dataAccessor;
                _this.setState({
                  loading: true
                });
                _context1.p = 1;
                _context1.n = 2;
                return Promise.all([dataAccessor.getTickets(ticketQuery), dataAccessor.getTicketTypes(), dataAccessor.filterTicketTypes({
                  devices: [],
                  timezone: _this.props.time.timezone.name
                })]);
              case 2:
                _yield$Promise$all4 = _context1.v;
                ticketsResponse = _yield$Promise$all4[0];
                ticketTypesResponse = _yield$Promise$all4[1];
                filteredTicketTypeResponse = _yield$Promise$all4[2];
                ticketList = ticketsResponse.content.length > 0 ? ticketsResponse.content.map(function (t) {
                  return Object.assign({}, t, {
                    type: _constants.LOGBOOK_TICKET,
                    creator: getFormattedUserName(t.creatorId, _this.props.users),
                    created: new Date(t.created).getTime()
                  });
                }) : [];
                filteredTicketTypes = ticketTypesResponse.filter(function (ticketType) {
                  return filteredTicketTypeResponse.includes(ticketType.id);
                });
                ticketing = {
                  ticketList: ticketList,
                  filteredTicketTypes: filteredTicketTypes,
                  ticketTypes: ticketTypesResponse
                };
                _this.setState(Object.assign({}, ticketing, {
                  loading: false
                }));
                return _context1.a(2, ticketing);
              case 3:
                _context1.p = 3;
                _t4 = _context1.v;
                _this.setState({
                  filteredTicketTypes: [],
                  ticketTypes: [],
                  loading: false
                });
              case 4:
                return _context1.a(2);
            }
          }, _callee1, null, [[1, 3]]);
        }));
        function fetchTickets(_x13) {
          return _fetchTickets.apply(this, arguments);
        }
        return fetchTickets;
      }()
    };
    return _this;
  }
  _inheritsLoose(TicketingController, _Component);
  var _proto = TicketingController.prototype;
  _proto.render = function render() {
    return this.props.children(this.state);
  };
  return TicketingController;
}(_react.Component), _TicketingController.defaultProps = {
  dataAccessor: undefined,
  users: undefined,
  devices: undefined,
  profile: undefined
}, _TicketingController)) || _class) || _class) || _class) || _class) || _class) || _class) || _class);
TicketingController.displayName = "TicketingController";